import { Accordion, Breadcrumb, BreadcrumbItem, Container, Image, Row } from 'react-bootstrap';
import { Heart } from 'react-bootstrap-icons';
import bannerImage from '../../resources/banner-questions.png';
import { useAppDispatch } from '../../hooks/redux';
import { userSlice } from '../../store/reducers/UserSlice/UserSlice';
import { useNavigate } from 'react-router-dom';

function FAQPage() {
  const navigate = useNavigate();

  return (
    <>
      <section id="intro-faqs" className="position-relative overflow-hidden">
        <div className="banner">
          <Image src={bannerImage} alt="banner" className="img-fluid" />

          <div className="container">
            <div className="banner-content position-absolute padding-large">
              <span className="d-inline-flex align-items-center text-nowrap sub-heading bg-light py-2 px-4 mb-4 border-radius-30 text-uppercase text-cadet-blue fw-medium">
                <svg className="heart primary-color me-2" width="20" height="20">
                  <Heart />
                </svg>
                Часто задаваемые вопросы
              </span>

              <h1 className="display-3 fw-bold text-dark">Вопрос-ответ</h1>
              <p className="mt-3 mb-4">
                Не нашли ответ на свой вопрос? Может, самое время записаться <br />
                на прием к ветеринарному врачу?
              </p>
              <a
                onClick={() => {
                  navigate('/online_record');
                }}
                className="btn btn-medium btn-primary btn-pill text-uppercase"
              >
                Записаться на прием
              </a>
            </div>
          </div>
        </div>
      </section>
      <Container>
        <p className="text-center" style={{ fontSize: '2.0rem' }}>
          Терапия
        </p>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Собака ездит задом по полу. Как отучить?</Accordion.Header>
            <Accordion.Body>
              На такое поведение собак провоцирует зуд в области ануса. Там находятся параанальные
              железы, в которых скапливается секрет. Обычно он выделяется при дефекации и железы
              очищаются, но иногда происходит их закупорка. В этом причина такого поведения собаки,
              скорее всего. Нельзя исключить и других причин зуда, например аллергическую реакцию. В
              любом случае стоит очистить параанальные железы от содержимого — для этого обратитесь
              к ветеринарному врачу.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              У соседского кота панлейкопения. Может ли заразиться наш котенок?
            </Accordion.Header>
            <Accordion.Body>
              Если ваш котенок не вакцинирован, то шансы заболеть высоки. Панлейкопения (чума кошек)
              — острая высокозаразная вирусная болезнь кошек. Без лечения многие кошки погибают,
              смертность не вакцинированных котят более 90%. Вирус передается прямым контактом или
              при контакте с выделениями (кал, моча, слюна). Также вирус передается через окружающую
              среду и предметы, сохраняясь на них в течение года. Ограничьте контакт с соседями и
              проведите дезинфекцию средствами гипохлорита натрия (Доместос, Белизна). Своевременная
              и правильная вакцинация значительно снижает вероятность заражений и повышает
              выживаемость у заболевших животных.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Несколько дней у котенка понос и рвота, какие лекарства ему дать?
            </Accordion.Header>
            <Accordion.Body>
              Такие симптомы у котят могут вызывают паразитарные болезни и вирусные (например,
              панлейкопения). Это может быть и проглатывание инородного тела. Некоторые болезни без
              экстренного правильного лечения могут закончиться смертью. Ваш котенок нуждается
              срочном в обследовании. Ветеринарный врач осмотрит его, сделает анализы, рентген,
              проведет инфузионную терапию и назначит лечение.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Моя кошка кашляет 2 недели. Стерилизована, 2 года. Давали микстуру от кашля - не
              помогает. Что еще можно сделать?
            </Accordion.Header>
            <Accordion.Body>
              Кашель может быть симптом заболеваний дыхательной системы — инфекции или астмы. Даже
              позывы на рвоту иногда похожи на кашель. Вам лучше обратиться к ветврачу — он осмотрит
              кошку, возможно сделает рентген в нескольких проекциях, возьмет анализы крови и смывы
              на инфекции.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <p className="text-center" style={{ fontSize: '2.0rem' }}>
          Стерилизация и кастрация
        </p>
        <Accordion>
          <Accordion.Item eventKey="4">
            <Accordion.Header>В каком возрасте можно стерилизовать кошку?</Accordion.Header>
            <Accordion.Body>
              Стерилизация кошки проводится в любом возрасте, но самый оптимальный возраст 6-8
              месяцев. По статистике, стерилизация, проведенная до первой течки, существенно снижает
              риск возникновения опухолей молочных желез.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>В каком возрасте можно кастрировать кота?</Accordion.Header>
            <Accordion.Body>
              Кастрация кота проводится в любом возрасте, но самый оптимальный возраст 6-8 месяцев.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <p className="text-center" style={{ fontSize: '2.0rem' }}>
          Хирургия
        </p>
        <Accordion>
          <Accordion.Item eventKey="6">
            <Accordion.Header>
              У кошки давно появились опухоли на животе, и теперь растут. Что делать?
            </Accordion.Header>
            <Accordion.Body>
              Необходимо показать кошку ветврачу. Если это опухоли молочных желез, то рекомендуемое
              лечение — хирургическое. Прогноз зависит от размера опухоли и её природы (нужно взять
              биопсию). Чем меньше размер опухоли, тем более благоприятен исход болезни. При
              обнаружении даже небольших узелков на теле вашего питомца — срочно обращайтесь в
              ветклинику.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7">
            <Accordion.Header>
              Собака проглотила кость, не ест, не пьет, очень вялая. Как ей помочь?
            </Accordion.Header>
            <Accordion.Body>
              Осмотрите ротовую полость собаки, если кость застряла во рту, вы сможете ее достать.
              Но лучше показаться ветврачу для тщательного осмотра и рентгеновского исследования
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </>
  );
}

export default FAQPage;
